export default "skymp5-front/0082a509823996b3af76f894fc359707.png";